import { render } from "./LoadingScreen.vue?vue&type=template&id=6e24059d&scoped=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&lang=js"

import "./LoadingScreen.vue?vue&type=style&index=0&id=6e24059d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e24059d"]])

export default __exports__